import { httpsCallable } from 'firebase/functions';
import type {
  AdminActivityCursor,
  ListAdminActivityInput,
  ListAdminActivityResult,
} from '@casetrace/shared';
import { functions } from './firebase';

export async function listAdminActivity(
  cursor?: AdminActivityCursor,
): Promise<ListAdminActivityResult> {
  const callable = httpsCallable<ListAdminActivityInput, ListAdminActivityResult>(
    functions,
    'listAdminActivity',
  );
  const input: ListAdminActivityInput = cursor ? { cursor } : {};
  return (await callable(input)).data;
}
